/* Videos diferidos — PageSpeed 2026-10-01.
   snippets/sir-video-tag.liquid con diferido: true deja la portada y las
   fuentes en data-*. Aquí se cargan cuando el vídeo entra (o está a punto de
   entrar) en pantalla. Un vídeo oculto con display:none (la versión de
   escritorio en el móvil y viceversa) nunca intersecta, así que nunca se baja. */
(function () {
  function cargar(v) {
    if (v.dataset.cargado) return;
    v.dataset.cargado = "1";
    if (v.dataset.poster) v.setAttribute("poster", v.dataset.poster);
    v.querySelectorAll("source[data-src]").forEach(function (s) { s.src = s.dataset.src; });
    v.querySelectorAll("img[data-src]").forEach(function (i) { i.src = i.dataset.src; });
    if (v.dataset.autoplay === "true") {
      // autoplay nativo restaurado: si play() se rechaza (pestaña en segundo
      // plano, datos aún sin llegar), el navegador lo arranca al poder.
      v.muted = true;
      v.autoplay = true;
    }
    v.load();
    if (v.dataset.autoplay === "true") {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }
  function iniciar() {
    var vids = document.querySelectorAll("video[data-diferido]:not([data-cargado])");
    if (!("IntersectionObserver" in window)) { vids.forEach(cargar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { cargar(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: "400px 0px" });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
  document.addEventListener("shopify:section:load", iniciar);
})();
